import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { resultAPI } from '../../services/api';
import { getErrorMessage } from '../../utils/errorHandler';

export const fetchResults = createAsyncThunk('results/fetchAll', async (params, { rejectWithValue }) => {
  try {
    const response = await resultAPI.fetchResults(params);
    return response.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to fetch results'));
  }
});

export const computeResults = createAsyncThunk('results/compute', async (data, { rejectWithValue }) => {
  try {
    const response = await resultAPI.computeResults(data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to compute results'));
  }
});

export const generateReportCards = createAsyncThunk('results/reportCards', async (data, { rejectWithValue }) => {
  try {
    const response = await resultAPI.generateReportCards(data);
    return response.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to generate report cards'));
  }
});

export const fetchRankings = createAsyncThunk('results/rankings', async (params, { rejectWithValue }) => {
  try {
    const response = await resultAPI.fetchRankings(params);
    return response.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to fetch rankings'));
  }
});

export const getResultAnalytics = createAsyncThunk('results/analytics', async (params, { rejectWithValue }) => {
  try {
    const response = await resultAPI.getResultAnalytics(params);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to fetch analytics'));
  }
});

const initialState = {
  results: [],
  rankings: [],
  analytics: null,
  loading: false,
  error: null,
};

const resultSlice = createSlice({
  name: 'results',
  initialState,
  reducers: {
    clearResultError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchResults.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchResults.fulfilled, (state, action) => { state.loading = false; state.results = action.payload.data || action.payload; })
      .addCase(fetchResults.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(computeResults.pending, (state) => { state.loading = true; })
      .addCase(computeResults.fulfilled, (state, action) => { state.loading = false; state.results = action.payload; })
      .addCase(computeResults.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(generateReportCards.fulfilled, (state) => { state.loading = false; })
      .addCase(fetchRankings.fulfilled, (state, action) => { state.rankings = action.payload.data || action.payload; })
      .addCase(getResultAnalytics.fulfilled, (state, action) => { state.analytics = action.payload; });
  },
});

export const { clearResultError } = resultSlice.actions;
export default resultSlice.reducer;
